import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Button, Divider, Link, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import { FixedSizeList } from "react-window";
import { useNavigate } from "react-router";

export const menuItems1 = [
  {
    text: "All Menu",
    route: "/allmenu",
  },
  {
    text: "Buy Gift Cards",
    route: "/",
  },
  {
    text: "Become a Caterer",
    route: "/becomecaterer",
  },
  {
    text: "Become a Driver",
    route: "/becomedriver",
  },
  {
    text: "Create Business Account",
    route: "/",
  },
];

export const menuItems2 = [
  {
    text: "About Us",
    route: "/about",
  },
  {
    text: "Blog",
    route: "/Blog",
  },
  {
    text: "Careers",
    route: "/Career",
  },
];

export const menuItems3 = [
  {
    text: "FAQ",
    route: "/about",
  },
  {
    text: "Blog",
    route: "/Blog",
  },
  {
    text: "How it works",
    route: "/",
  },
];

export default function Footer() {
  let navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          margin: { xl: "70px", lg: "60px", md: "10px", sm: "10px", xs: "5px" },
          // border: "1px solid red",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
            justifyContent: "space-between",
            // border:"1px solid red"
          }}
        >
          <Box
            display="flex"
            flexDirection={"column"}
            // justifyContent="center"
            // alignItems="center"
            textAlign={{ lg: "left", md: "left", xs: "center", sm: "center" }}

            //   minHeight="100vh"
          >
            <Box>
              <Box>
                <Typography
                  className="eatcoast"
                  fontWeight={"600"}
                  // fontSize={"40px"}
                  sx={{
                    fontSize: {
                      lg: "40px",
                      md: "40px",
                      sm: "30px",
                      xs: "25px",
                    },
                  }}
                >
                  EatCoast
                </Typography>
                <Typography
                  sx={{
                    marginTop: "16px",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "16px",
                    },
                    letterSpacing: "0.01em",
                    width: { lg: "352px", md: "352px", sm: "100%", xs: "100%" },
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </Typography>
              </Box>
              <Box marginTop={"20.48px"}>
                <Link component="button">
                  <img
                    src="./images/TwitterGray.svg"
                    alt=""
                    width={"23.04px"}
                    height={"23.04px"}
                  />
                </Link>
                <Link component="button" sx={{ marginLeft: "12.96px" }}>
                  <img
                    src="./images/InstagramGray.svg"
                    alt=""
                    width={"23.04px"}
                    height={"23.04px"}
                  />
                </Link>
                <Link component="button" sx={{ marginLeft: "12.96px" }}>
                  <img
                    src="./images/FacebookGray.svg"
                    alt=""
                    width={"23.04px"}
                    height={"23.04px"}
                  />
                </Link>
              </Box>

              <Box>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "20px",
                      //   letterSpacing: "0.015em",
                      color: "#1A1824",
                      marginTop: "48.48px",
                    }}
                  >
                    Our Offices
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  flexDirection={"row"}
                  fontWeight={"400"}
                  fontSize={"18px"}
                  marginTop={"8px"}
                  textAlign={{
                    lg: "left",
                    md: "left",
                    xs: "center",
                    sm: "center",
                  }}
                  sx={{
                    justifyContent: {
                      lg: "left",
                      md: "left",
                      sm: "center",
                      xs: "center",
                    },
                  }}

                  // justifyContent="center"
                  // alignItems="center"
                >
                  <Box>
                    <Typography sx={{ letterSpacing: "0.015em" }}>
                      Greater Vercouver
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ marginLeft: "19px", marginRight: "19px" }}
                    >
                      |
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>Victoria</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: { lg: "0px", md: "0px", sm: "70px", xs: "70px" },
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",

                  //   letterSpacing: "0.015em",
                  color: "#1A1824",
                  // marginTop: "48.48px",
                  textAlign: {
                    sm: "center",
                    xs: "center",
                    md: "left",
                    lg: "left",
                  },
                }}
              >
                Service
              </Typography>
              <Box
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#9EA3AE",
                  marginTop: "32px",
                  // justifyContent:{sm: "center", xs: "center", md: "center"}
                }}
              >
                <List>
                  {menuItems1.map((item) => (
                    <ListItem
                      onClick={() => navigate(`${item.route}`)}
                      button
                      key={item.text}
                      sx={{
                        textAlign: {
                          lg: "left",
                          md: "left",
                          sm: "center",
                          xs: "center",
                          justifyContent: "center",
                          px: "3%",
                          paddingRight: "0%",
                          // border:"1px solid red"
                        },
                      }}
                    >
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  //   letterSpacing: "0.015em",
                  color: "#1A1824",
                  //   marginTop: "48.48px",
                  textAlign: {
                    sm: "center",
                    xs: "center",
                    md: "left",
                    lg: "left",
                  },
                  px: "5%",
                }}
              >
                Company
              </Typography>
              <Box
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#9EA3AE",
                  marginTop: "32px",
                }}
              >
                <List>
                  {menuItems2.map((item) => (
                    <ListItem
                      button
                      key={item.text}
                      onClick={() => navigate(`${item.route}`)}
                      sx={{
                        textAlign: {
                          sm: "center",
                          xs: "center",
                          md: "left",
                          lg: "left",
                        },
                        justifyContent: "center",
                        // px: "5%",
                        paddingRight: "0%",
                        // border:"1px solid red"
                      }}
                    >
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: { lg: "center", md: "center" },
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  //   letterSpacing: "0.015em",
                  color: "#1A1824",
                  //   marginTop: "48.48px",
                  textAlign: {
                    sm: "center",
                    xs: "center",
                    md: "left",
                    lg: "left",
                  },
                  px: "5%",
                }}
              >
                Support
              </Typography>
              <Box
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#9EA3AE",
                  marginTop: "32px",
                }}
              >
                <List>
                  {menuItems3.map((item) => (
                    <ListItem
                      button
                      key={item.text}
                      onClick={() => navigate(`${item.route}`)}
                      sx={{
                        textAlign: {
                          sm: "center",
                          xs: "center",
                          md: "left",
                          lg: "left",
                        },
                        justifyContent: "center",
                        // px: "2%",
                        paddingRight: "0%",
                        // border: "1px solid red",
                      }}
                    >
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>

            <Box justifyContent={"center"} marginTop={"80px"}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: { sm: "center", xs: "center", md: "center" },
                }}
              >
                <Button
                  sx={{
                    color: "#9EA3AE",
                    textTransform: "capitalize",
                    fontSize: "18px",
                    fontWeight: "400",
                  }}
                >
                  <img
                    src="./images/GooglePlay.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                </Button>

                <Button
                  sx={{
                    color: "#9EA3AE",
                    textTransform: "capitalize",
                    fontSize: "18px",
                    fontWeight: "400",
                  }}
                >
                  <img
                    src="./images/AppStore.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                </Button>
                {/* <Link>
                  <img
                    src="./images/GooglePlay.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                </Link> */}
                {/* <Link>
                  <img
                    src="./images/AppStore.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                </Link> */}
              </Box>
            </Box>
          </Box>
        </Box>
        <Divider variant="middle" />

        <Box justifyContent="space-between">
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                lg: "row",
                md: "row",
                sm: "column",
                xs: "column",
              },
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  fontSize: { lg: "18px", md: "18px", sm: "1rem", xs: "14px" },
                  color: "#9EA3AE",
                }}
              >
                @ 2021 EatCoast. All Rights Reserved.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box>
                <Button
                  sx={{
                    color: "#9EA3AE",
                    textTransform: "capitalize",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "1rem",
                      xs: "14px",
                    },
                    fontWeight: "400",
                    marginRight: "50px",
                  }}
                  onClick={() => navigate("/Terms&Conditions")}
                >
                  Terms of Service
                </Button>
              </Box>
              <Box>
                <Button
                  sx={{
                    color: "#9EA3AE",
                    textTransform: "capitalize",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "1rem",
                      xs: "14px",
                    },
                    fontWeight: "400",
                    marginRight: "50px",
                  }}
                >
                  Privacy Policy
                </Button>

                {/* <Typography
                  sx={{
                    fontWeight: "400",
                    fontSize: "18px",
                    color: "#9EA3AE",
                  }}
                >
                  Privacy Policy
                </Typography> */}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
